import { DebtLabel, getSubscriptionLabel, PriceLabel, RenderSubscriptionStatus } from '@/components/features/shared/utils'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { BillingFrequency } from '@/domain/offerings/offering'
import { SubscriptionData } from '@/domain/subscriptions/subscriptions'
import { capitalizeString } from '@/utils/strings'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

interface SelectBillingPeriodForModifyModalProps {
  isOpen: boolean
  onClose: () => void
  subscriptions: SubscriptionData[]
  onSelect: (sub: SubscriptionData) => void
  isPending: boolean
}

export const SelectBillingPeriodForModifyModal = ({
  isOpen,
  onClose,
  subscriptions,
  onSelect,
  isPending,
}: SelectBillingPeriodForModifyModalProps) => {
  const getSubscriptionPeriod = (periodStartDate: Date, billingFrequency: BillingFrequency = BillingFrequency.MONTHLY) => {
    return billingFrequency === BillingFrequency.ANNUAL ?
      format(periodStartDate, 'yyyy')
      : capitalizeString(format(periodStartDate, 'MMMM', { locale: es })) + '/' + format(new Date(periodStartDate), 'yyyy', { locale: es })
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>Seleccionar Período a Modificar</DialogTitle>
          <DialogDescription>
            Elige un período para modificar su rango o precio.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 my-4 flex-grow flex flex-col min-h-0 overflow-y-auto pr-2">
          {subscriptions.map((sub) => (
            <Button
              key={sub.billingPeriodId}
              variant="outline"
              className="w-full justify-between h-auto py-3 px-4 shrink-0"
              onClick={() => onSelect(sub)}
              disabled={isPending}
            >
              <div className="flex flex-col items-start gap-1">
                <span className="font-medium">{sub.offeringName}</span>
                <span className="text-xs text-muted-foreground">
                  {getSubscriptionLabel(sub.periodStartDate, sub.periodEndDate, sub.billingFrequency)}
                </span>
              </div>
              <div className="flex flex-col items-end gap-1 shrink-0">
                <RenderSubscriptionStatus subscriptionStatus={sub.periodStatus} />
                {sub.outstandingAmount > 0 && (
                  <DebtLabel amount={sub.outstandingAmount} />
                )}
                {sub.outstandingAmount === 0 && (
                  <PriceLabel price={sub.totalAmount} />
                )}
              </div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
